export default {
  firstName: {
    en: 'First name',
  },
  lastName: {
    en: 'Last name',
  },
  cardNumber: {
    en: 'Card number',
  },
  month: {
    en: 'MM',
  },
  year: {
    en: 'YY',
  },
  cvv: {
    en: 'CVC',
  },
  postalCode: {
    en: 'Billing ZIP / Postal code',
  },
}
